module.exports = __webpack_public_path__ + "img/sjz_summary_Image.8f98214d.png";